import React from "react";
import "../style/newApplication.css";
import "../style/dots.css";
import _ from "lodash";
import { Link } from "react-router-dom";
import { isAragUser, isSolicitorUser, formatSolicitorOptionLabel } from "../helpers/functions";
import {
	APPLICATION_FORM_FIELDS,
	LEGAL_ADVICE_TEXT,
	WORK_SOURCE_EDIT_MESSAGE,
} from "../helpers/variables";
import DeleteAnswerModal from "./ApplicationPolicy/deleteAnswerModal";
import { checkIfQuestionHasPendingChanges } from "../helpers/questions/functions";
import PlainApplicationForm from "./applicationForm/plainApplicationForm";
import FullApplicationForm from "./applicationForm/fullApplicationForm";
import AnswerEditModal from "./applicationForm/answerEditModal";
import CaseForm from "./applicationForm/caseForm";
import ApplicationPremiumSettingsHOC from "../containers/ApplicationPremiumSettings/applicationPremiumSettingsHOC";
import {
	SHOW_APPLICATION_PREMIUM_STATUSES, DOTS, TERTIARY, ERROR, RIGHT,
	SOLICITOR, DRAFT, HEADING_2, MEDIUM, DOTTED, INITIAL_OPTIONS, INFO,
} from "../helpers/constants";
import { Button, Heading, FormGroup, Loader, HorizontalRule, Alert } from "arag-ui-lib";
import { FORM_GROUP_VARIANTS } from "../helpers/formGroupVariants";
import RevisionsModal from "./applicationForm/revisionsModal";
import CONTENT_STRINGS from "../helpers/contentStrings";
import ApplicationPremiumSettingsModal from "./PremiumSettings/applicationPremiumSettingsModal";

const NewApplication = (props) => {
	const {
		isDeleteAnswerModalOpen,
		closeDeleteAnswerModal,
		onDeleteAnswerConfirm,
		isHistoryModalOpen,
		updateMedicalExpertFees,
		handleMedicalFeesTableRows,
		mapEditingQuestionOrFieldToEditingSetting,
		user,
		router,
		Store,
		SolicitorFirms,
		AgentsList,
		groups,
		newApplicationFormMessage,
		handleSolicitorFirmSelect,
		handleSolicitorSelect,
		isEditModalOpen,
		closeEditModal,
		openEditModal,
		UserRole,
		openDeleteAnswerModal,
		checkIfQuestionIsEditable,
		HandleDateChange,
		onClickActionLink,
		deleteModalQuestionMachineName,
		openEditQuestionAnswerModal,
	} = props;
	if (
		isSolicitorUser(user.loggedInUser.roles) &&
		!user.loggedInUser.allowedToCreateApplications &&
		router.location.pathname === "/new-application"
	) {
		return (
			<div className={"row"}>
				<div className={"col-sm-12 mb-15"}>
					<Alert variant={ERROR} label={CONTENT_STRINGS.APPLICATION_CREATION_NOT_PERMITTED} />
				</div>
			</div>
		);
	}
	const caseTypeOptions = [
		{ key: "", label: CONTENT_STRINGS.NONE },
		...Store.caseTypes.map((caseType) => {
			return { key: caseType.id, label: caseType.name };
		}),
	];
	const subCaseTypeOptions = [
		{ key: "", label: CONTENT_STRINGS.NONE },
		..._.filter(Store.subCaseTypes, (subCase) => {
			return subCase.caseTypeId.toString() === Store.selectedCaseType;
		})
		.map((subCaseType) => {
			return { key: subCaseType.id, label: subCaseType.name };
		}),
	];
	const maxDateOfBirth = new Date();
	let workSourceOptions = INITIAL_OPTIONS;
	const groupWorkSource = Store.solicitorGroupWorkSources.map((option) => {
		return { key: option.id, label: option.name };
	})
	if (Store.solicitorGroupWorkSources.length > 0) {
		workSourceOptions = [
			...workSourceOptions,
			...groupWorkSource,
		];
	}
	const legalAdviceGroupOptions = [
		{ value: "", label: CONTENT_STRINGS.NONE },
		...SolicitorFirms.lawsysFirms.map((value) => {
			return {
				value: value.id,
				label: value.name,
				aragProvider: value.aragProvider,
			};
		}),
	];
	const agentGroupOptions = [ 
		{ key: "", label: CONTENT_STRINGS.NONE }, 
		...AgentsList.allSolicitorUsers.map((value) => {
			return {
				key: value.userId,
				label: value.username,
			};
		}),
	];

	return (
		<div className="row">
			{
				Store.selectedApplication &&
				Store.selectedApplication.id &&
				checkIfQuestionHasPendingChanges(null, Store.selectedApplication, APPLICATION_FORM_FIELDS.WORK_SOURCE.fieldName)
				?
					<div className={"col-sm-12 mt-15"}>
						<div className={"form-horizontal"}>
						<Alert variant={INFO} label={WORK_SOURCE_EDIT_MESSAGE} />
						</div>
					</div>
				: 
					null
			}
			<DeleteAnswerModal
				isOpen={isDeleteAnswerModalOpen}
				onClose={closeDeleteAnswerModal}
				onConfirm={onDeleteAnswerConfirm}
				isLoading={Store.updatingQuestionAnswer}
				errorMessage={Store.updatingQuestionAnswerFail}
				deleteModalQuestionMachineName={deleteModalQuestionMachineName}
			/>
			<RevisionsModal 
				isHistoryModalOpen={isHistoryModalOpen}
				Store={Store}
				{...props}
			/>
			<AnswerEditModal 
				workSourceOptions={workSourceOptions}
				openDeleteAnswerModal={openDeleteAnswerModal}
				checkIfQuestionIsEditable={checkIfQuestionIsEditable}
				opponentQuestions={Store.opponentQuestions}
				{...props}
			/>
			{
				isSolicitorUser(user.loggedInUser.roles) &&
				!user.loggedInUser.toba &&
				router.location.pathname === "/new-application" &&
				!Store.getApplicationFromErrorMessage 
				?
					<div className={"col-sm-12 mb-15"}>
						<Alert 
							variant={ERROR}
							label={ 
								<span>
									{CONTENT_STRINGS.ACCEPT_LATEST}
									<Link to={'/accept-toba'}>{CONTENT_STRINGS.TOBA}</Link>
									{CONTENT_STRINGS.ACCEPT_LATEST_DESCRIPTION}
								</span>
							}
						/>
					</div>
				:
					null
			}
			<div className="col-sm-12 newApplication-wrapper">
				{Store.fetchingSelectedApp
				?
					<div className="form-group">
						<div className="col-sm-12">
						<Loader variant={DOTS} dotSize={MEDIUM}/>
						</div>
					</div>
				:
					<div>
						<div className="row">
							{Object.keys(Store.selectedApplication).length !== 0 &&
							Store.selectedApplication.constructor === Object 
							? 
								null 
							:
								<div className="col-sm-12 ">
									<Heading variant={HEADING_2} title={CONTENT_STRINGS.CREATE_NEW_APPLICATION} />
								</div>
							}
						</div>
						<div className="row">
							{Object.keys(Store.selectedApplication).length !== 0 && Store.selectedApplication.constructor === Object
							? 
								null 
							:
								<p className="col-sm-10">
									{newApplicationFormMessage.applicationFormMessage
									? 
										newApplicationFormMessage.applicationFormMessage.body
									:
										null
									}
								</p>
							}
						</div>
						<div className={"row mt-15 noprintarea"}>
							{isSolicitorUser(user.loggedInUser.roles) 
								?
									<div className={"col-sm-12"}>
										<Button
											onClick={() => window.print()}
											variant={TERTIARY}
											arrowDirection={RIGHT}
											label={CONTENT_STRINGS.PRINT}
											buttonTestId={"policy-application-PrintButton"}
										/>
									</div>
								:
									null
							}
							{isAragUser(user.loggedInUser.roles)
							?
								router.location.pathname.includes("/new-application") 
								?
									<div className='col-sm-12'>
										<div>
											<FormGroup 
												labelSize={"col-sm-3"}
												inputSize={"col-sm-6"}
												label={`Select ${LEGAL_ADVICE_TEXT} Firm`}
												variant={FORM_GROUP_VARIANTS.SEARCHABLE_LIST}
												inputProps={{
													instanceId: "newApplicationSolicitorGroup",
													value: legalAdviceGroupOptions.find(o => o.value === Store.solicitorFirmIdSelected) || null,
													onChange: (option) => handleSolicitorFirmSelect(option ? option.value : ""),
													options: legalAdviceGroupOptions,
													formatOptionLabel: formatSolicitorOptionLabel,
												}}
												formGroupTestId={'new-application-SelectSolicitorGroup'}
											/>
										</div>
										{Store.solicitorFirmIdSelected !== ""
											?
												!AgentsList.fetching 
												?
													<div>
														<FormGroup
															labelSize={"col-sm-3"}
															inputSize={"col-sm-6"}
															label={`Select ${LEGAL_ADVICE_TEXT} user`}
															variant={FORM_GROUP_VARIANTS.SELECT}
															inputProps={{
																name: "selectedSolicitorCaseType",
																value: Store.userId,
																onChange: (evt) => handleSolicitorSelect(evt.target.value),
																options: agentGroupOptions,
															}}
															formGroupTestId={'new-application-SelectSolicitorCaseType'}
														/>
													</div>
												:
													<div>
														<Loader variant={DOTS} dotSize={MEDIUM}/>
													</div>
											:
												null
										}
									</div>
								:
									null
							: 
								null
							}
						</div>
						{Store.userId == "" && isAragUser(user.loggedInUser.roles) && router.location.pathname.includes("/new-application") 
						? 
							null
						:
							<div>
								<div className="row noprintarea">
								<div className="col-sm-12">
									<HorizontalRule variant={DOTTED} className="appFormRefSettings-hr" />
								</div>
								</div>
								{!groups.fetchingSolicitorGroupCaseTypes 
								?
									<CaseForm
										{...props}
										caseTypeOptions={caseTypeOptions}
										subCaseTypeOptions={subCaseTypeOptions}
										workSourceOptions={workSourceOptions}
									/>
								:
									<div className="col-sm-12">
										<Loader variant={DOTS} dotSize={MEDIUM}/>
									</div>
								}
								<div className="row">
									<div className="col-sm-12">
										<HorizontalRule variant={DOTTED} className="appFormRefSettings-hr" />
									</div>
								</div>
							</div>
						}
						{Store.getApplicationFromErrorMessage
						?
							<div className={"row"}>
								<div className={"col-sm-12"}>
								<Alert variant={ERROR} label={Store.getApplicationFromErrorMessage} />
								</div>
							</div>
						:
							null
						}
						{
							Object.keys(Store.selectedApplication).length !== 0 &&
							Store.selectedApplication.constructor === Object &&
							(Store.selectedApplication.policyStatus !== DRAFT || UserRole !== SOLICITOR) 
						?
							<div className="">
								<PlainApplicationForm
									{...props}
									caseTypeOptions={caseTypeOptions}
									subCaseTypeOptions={subCaseTypeOptions}
									maxDateOfBirth={maxDateOfBirth}
									workSourceOptions={workSourceOptions}
									openDeleteAnswerModal={openDeleteAnswerModal}
									checkIfQuestionIsEditable={checkIfQuestionIsEditable}
									HandleDateChange={HandleDateChange}
									openEditQuestionAnswerModal={openEditQuestionAnswerModal}
								/>
								{isAragUser(user.loggedInUser.roles) &&
								SHOW_APPLICATION_PREMIUM_STATUSES.includes(Store.selectedApplication.policyStatusMachineName)
								?
									<div>
										<ApplicationPremiumSettingsModal
											isOpen={isEditModalOpen}
											handleClose={closeEditModal}
											onEditStaged={openEditModal}
											isEditStaged={isEditModalOpen}
											isChangingStatusOfApp={false}
											showTable={false}
											isEditMode={true}
											isApplicationPremium={true}
											applicationPremiumSaveButtonLabel={CONTENT_STRINGS.SAVE_CHANGES}
											applicationPremiumCancelHandler={closeEditModal}
											selectedApplicationCaseTypeId={Store.selectedApplication.caseTypeId}
											onCancel={closeEditModal}
										/>
										{!isEditModalOpen
										?
											<div>
												<HorizontalRule />
												<ApplicationPremiumSettingsHOC
													isChangingStatusOfApp={false}
													showTable={true}
													isEditMode={false}
													isApplicationPremium={true}
													applicationPremiumCancelHandler={() => null}
													selectedApplicationCaseTypeId={Store.selectedApplication.caseTypeId}
													onApplicationPremiumEdit={openEditModal}
													onCancel={closeEditModal}
													onEditStaged={openEditModal}
													isEditStaged={isEditModalOpen}

												/>
											</div>
										:
											null
										}
									</div>
								: 
									null
								}
							</div>
						:
							null
						}
						{
							(
								(Store.showForm && !Store.fetching) || (Object.keys(Store.selectedApplication).length !== 0 &&
								Store.selectedApplication.constructor === Object &&
								Store.selectedApplication.draft &&
								!Store.fetching &&
								isSolicitorUser(user.loggedInUser.roles))
							) &&
							Object.keys(Store.application).length !== 0 &&
							Store.application.constructor === Object
						?
							<FullApplicationForm
								{...props}
								caseTypeOptions={caseTypeOptions}
								subCaseTypeOptions={subCaseTypeOptions}
								maxDateOfBirth={maxDateOfBirth}
								workSourceOptions={workSourceOptions}
								updateMedicalExpertFees={updateMedicalExpertFees}
								handleMedicalFeesTableRows={handleMedicalFeesTableRows}
								application={Store.application}
								mapEditingQuestionOrFieldToEditingSetting={mapEditingQuestionOrFieldToEditingSetting}
								openDeleteAnswerModal={openDeleteAnswerModal}
								checkIfQuestionIsEditable={checkIfQuestionIsEditable}
								HandleDateChange={HandleDateChange}
								onClickActionLink={onClickActionLink}
								openEditQuestionAnswerModal={openEditQuestionAnswerModal}
							/>
						: 
							Store.fetching 
							?
								<div className="form-group">
									<div className="col-sm-12">
										<Loader variant={DOTS} dotSize={MEDIUM}/>
									</div>
								</div>
							:
								<div>
									{!Store.referralExists
									?
										<div className="col-sm-12">
											<Alert variant={ERROR} label={CONTENT_STRINGS.NO_APPLICATION_REFERRAL_SETTING}/>
										</div>
									:
										null
									}
								</div>
						}
					</div>
				}
			</div>
		</div>
	);
};
export default NewApplication;
